import { render, staticRenderFns } from "./partnerPool.vue?vue&type=template&id=fdb0b206&scoped=true"
import script from "./partnerPool.vue?vue&type=script&lang=js"
export * from "./partnerPool.vue?vue&type=script&lang=js"
import style0 from "./partnerPool.vue?vue&type=style&index=0&id=fdb0b206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb0b206",
  null
  
)

export default component.exports